import { reactive } from 'vue';
import util from '@/util/util.js'; // 根据你的项目结构调整路径

let connectSocketOff = null;
let msgTimeId = null;
let socketCou = 0;
var socketThis = 0;
let socketMsg = [];

const socketSet = reactive({
    send_uid: 0,
});

const sendSocket = function (sendObj = {}, exec = 0) {
    if (sendObj['send_uid']) {
        socketSet.send_uid = sendObj['send_uid'];
    } else {
        if (!socketSet.send_uid) {
            return false;
        }
        sendObj['send_uid'] = socketSet.send_uid;
    }

    if (exec) {
        sendObj.execOff = 1;
        sendObj.exec = exec;
    } else {
        sendObj.execOff = 0;
        sendObj.exec = {
            name: '',
            data: '',
        };
    }

    const data = JSON.stringify(sendObj);

    if (!isSocket()) {
        console.log('发送内容__ajax：', sendObj);
        if (sendObj['execOff']) {
            util.request({
                url: '/coom/task/socket/send',
                data: {
                    info: data,
                },
                success(res) {
                    if (res.code === 200) {
                        res = res.data;
                        // 使用 Vue 3 的事件总线或其他方式通知组件
                        console.log('收到的内容------', res);

                        if(socketThis){
                            socketThis.$eventBus.emit('webAppOn', res);
                        }
                    }
                },
                fail(e) {
                    console.error('请求失败', e);
                },
            });
        }else{
            if(socketCou == 0){
                socketMsg.push(data)
            }
        }
    } else {
        console.log('发送内容__send：', sendObj);
        connectSocketOff.send(data);
    }
};

const isSocket = function () {
    return connectSocketOff && connectSocketOff.readyState === WebSocket.OPEN;
};

const getSocket = function (taht = false) {
    console.log('------创建链接------');
    socketThis = taht

    if (connectSocketOff) {
        console.log('------清除链接------');
        connectSocketOff.close();
        connectSocketOff = null;
    }

    // connectSocketOff = new WebSocket('wss://wss.qingsuiwang.com:5555');
    connectSocketOff = new WebSocket('wss://wss.qingsuiwang.com:5105');

    connectSocketOff.onopen = function () {
        console.log('-----------连接已打开！', connectSocketOff);

        if (socketCou > 0) {
            util.setSendSocket(true);
        }else{
            if(socketMsg.length > 0){
                socketMsg.forEach(val => {
                    connectSocketOff.send(val);
                })
            }
        }

        socketCou++;
    };

    connectSocketOff.onerror = function () {
        console.log('-----------连接打开失败！');
    };

    connectSocketOff.onmessage = function (event) {
        let res;
        try {
            res = JSON.parse(event.data);
        } catch (e) {
            res = event.data;
        }

        console.log('收到的内容------', res);
        // 使用 Vue 3 的事件总线或其他方式通知组件
        if(socketThis){
            socketThis.$eventBus.emit('webAppOn', res);
        }

    };

    connectSocketOff.onclose = function () {
        console.log('-----------连接已关闭！', connectSocketOff);
        if (msgTimeId) {
            clearInterval(msgTimeId);
        }

        connectSocketOff = null;

        reconnectWebSocket();
    };

    msgTimeId = setInterval(function () {
        const data = JSON.stringify({
            uid: 0,
            way: 'ping',
        });

        if (isSocket()) {
            connectSocketOff.send(data);
        }
    }, 50000);
};

function reconnectWebSocket() {
    console.log('++++-----++++启动重新链接++++-----++++');

    setTimeout(() => {
        getSocket();
    }, 2000); // 2秒后重连
}

const closeSocket = function () {
    if (connectSocketOff) {
        connectSocketOff.close();
    }
};

export { sendSocket, getSocket, isSocket, closeSocket };